export function getFinanceRouteParams(search) {
    const urlParams = new URLSearchParams(search);

    return {
        ul: urlParams.get('ul') || 3,
        li: urlParams.get('li'),
        tipo: urlParams.get('tipo'),
        operacaoUUID: urlParams.get('operacao'),
        uuid: urlParams.get('uuid'),
        btnText: urlParams.get('btnText') || 'Cadastrar',
        hasChanged: urlParams.get('hasChanged') === 'true',
        origem: urlParams.get('origem'),
    };
}

export function buildFinanceParams({ ul, li, tipo, operacaoUUID, uuid, btnText, origem, hasChanged }) {
    const params = new URLSearchParams();

    if (ul !== undefined && ul !== null) params.set('ul', ul);
    if (li !== undefined && li !== null) params.set('li', li);
    if (tipo !== undefined && tipo !== null) params.set('tipo', tipo);
    if (operacaoUUID !== undefined && operacaoUUID !== null) params.set('operacao', operacaoUUID);
    if (uuid !== undefined && uuid !== null) params.set('uuid', uuid);
    if (btnText !== undefined && btnText !== null) params.set('btnText', btnText);
    if (hasChanged !== undefined && hasChanged !== null) params.set('hasChanged', String(hasChanged));
    if (origem !== undefined && origem !== null) params.set('origem', origem);

    return params;
}
